import {
  AuditOutlined,
  BarChartOutlined,
  DashboardOutlined,
  ExportOutlined,
  FileAddOutlined,
  FileTextOutlined,
  EyeOutlined,
  MonitorOutlined,
  TeamOutlined,
  UploadOutlined
} from "@ant-design/icons";
import type { ReactNode } from "react";

import type { ModuleId } from "../api/types";
import { AdminsPage } from "./admins/AdminsPage";
import { AnswerSheetsPage } from "./answer-sheets/AnswerSheetsPage";
import { CandidatesPage } from "./candidates/CandidatesPage";
import { ExportsPage } from "./exports/ExportsPage";
import { ProctorPage } from "./proctor/ProctorPage";
import { OverviewPage } from "./overview/OverviewPage";
import { PapersPage } from "./papers/PapersPage";
import { Placeholder } from "./Placeholder";
import { RosterPage } from "./roster/RosterPage";
import { ScoresPage } from "./scores/ScoresPage";

export interface ModuleDefinition {
  id: ModuleId;
  title: string;
  description: string;
  icon: ReactNode;
  element: ReactNode;
}

function placeholder(id: ModuleId, title: string, description: string, icon: ReactNode): ModuleDefinition {
  return { id, title, description, icon, element: <Placeholder title={title} description={description} /> };
}

/** Display order of the home tiles and the side menu. The server decides which ids a role may see. */
export const MODULE_REGISTRY: readonly ModuleDefinition[] = [
  { id: "overview", title: "总览", description: "各考点登录、提交和实际参加人数", icon: <DashboardOutlined />, element: <OverviewPage /> },
  { id: "candidates", title: "考生管理", description: "考生名单、账号状态、登录与提交详情", icon: <TeamOutlined />, element: <CandidatesPage /> },
  { id: "roster", title: "名单导入", description: "上传考生名单并生成登录账号", icon: <UploadOutlined />, element: <RosterPage /> },
  { id: "papers", title: "试卷管理", description: "上传试卷、设置开考时间、选择各组当前使用的试卷", icon: <FileAddOutlined />, element: <PapersPage /> },
  { id: "scores", title: "成绩管理", description: "全组即时评分、分数分布、各考点与各题统计、成绩下载", icon: <BarChartOutlined />, element: <ScoresPage /> },
  { id: "answer-sheets", title: "答卷管理", description: "查看、打印和下载考生的答卷", icon: <FileTextOutlined />, element: <AnswerSheetsPage /> },
  { id: "exports", title: "导出", description: "成绩、答案、参加人数、答卷与考题文档下载", icon: <ExportOutlined />, element: <ExportsPage /> },
  { id: "proctor", title: "考场监控", description: "本考点考生的登录与答题情况", icon: <EyeOutlined />, element: <ProctorPage /> },
  { id: "admins", title: "管理员账号", description: "新建、编辑、重置密码和停用管理员账号", icon: <AuditOutlined />, element: <AdminsPage /> },
  placeholder("system", "系统监控", "技术团队查询系统信息", <MonitorOutlined />)
];

export function moduleById(id: string): ModuleDefinition | undefined {
  return MODULE_REGISTRY.find((module) => module.id === id);
}
